<div class="main-container">
  @if (platformAccount()) {
    <div class="cards">
      <div class="drawer-card">
        <div class="drawer-card-header">
          Location
          <span class="drawer-card-badge"
            >Warehouse {{ platformAccount()?.serviceCenter }}</span
          >
        </div>
        <div class="drawer-card-body">
          <div class="store-name">{{ platformAccount()?.accountName }}</div>
          <div class="address">
            {{ address.streetAddress1
            }}{{ address.streetAddress2 ? ", " + address.streetAddress2 : "" }}
            <br />
            {{ address.city }}{{ address.state ? ", " + address.state : ""
            }}{{ address.zip ? " " + address.zip : "" }}
          </div>
          <div class="kv-grid bordered-top">
            <span class="label">COD</span>
            <span>{{ platformAccount()?.codCode || "—" }}</span>
            <!-- EXT-6537: spelled-out labels, never the raw JFWTYP/ECSTS codes. -->
            <span class="label">Elite</span>
            <span>{{ eliteLabel() ?? "—" }}</span>
            <span class="label">Ecom</span>
            <span>{{ ecomLabel() ?? "—" }}</span>
            <span class="label">Established</span>
            <span>{{ established() }}</span>
          </div>
        </div>
      </div>

      <div class="drawer-card">
        <div class="drawer-card-header">Contacts</div>
        <div class="drawer-card-body">
          <div class="kv-grid">
            <span class="label">Phone</span>
            <a [href]="'tel:' + platformAccount()?.phone">{{
              platformAccount()?.phone | phone
            }}</a>
            <span class="label">Owner</span>
            <span>{{ platformAccount()?.ownerName }}</span>
            <span class="label">Manager</span>
            <span>{{ platformAccount()?.managerName || "—" }}</span>
            <span class="label">MDM</span>
            <span>{{ platformAccount()?.dealerRelationsRep || "—" }}</span>
          </div>
        </div>
      </div>

      <div class="drawer-card">
        <div class="drawer-card-header">
          Promotions
          <span class="drawer-card-badge"
            >{{ activePromotionCount() }} active</span
          >
        </div>
        <div class="drawer-card-body promotions-body">
          @if (promotionsLoading()) {
            <div class="promo-row"><span class="na">…</span></div>
          } @else if (promotionBalances().error) {
            <div class="promo-row"><span class="na">Unavailable</span></div>
          } @else if (promotionBalances().promotions.length === 0) {
            <div class="promo-row">
              <span class="na">Not enrolled in any promotions</span>
            </div>
          } @else {
            @for (promotion of promotionBalances().promotions; track $index) {
              <div
                class="promo-row"
                [class.inactive]="!promotion.active"
                [matTooltip]="promotion.active ? '' : 'Inactive'"
                matTooltipPosition="above"
              >
                <span>{{ promotion.description }}</span>
                <span class="promo-value">{{ promotion.value }}</span>
              </div>
            }
          }
        </div>
      </div>

      <div class="drawer-card">
        <div class="drawer-card-header">
          Users
          <span class="drawer-card-badge">{{ dealerUsers().length }}</span>
          @if (canCreateDealerUser()) {
            <span class="add-user" (click)="addUser()">+ Add user</span>
          }
        </div>
        <div class="drawer-card-body user-list">
          @if (dealerUsersLoading()) {
            <span class="na">Loading users…</span>
          } @else if (dealerUsersError()) {
            <span class="na">Unable to load users.</span>
          } @else if (dealerUsers().length === 0) {
            <span class="na">No users found for this account.</span>
          } @else {
            @for (user of sortedDealerUsers(); track user.documentId) {
              <div class="user-row">
                <i
                  class="status-dot"
                  [ngClass]="getUserStatus(user).colorClass"
                  [matTooltip]="getUserStatus(user).toolTip"
                  matTooltipPosition="above"
                ></i>
                <div class="user-info">
                  <span class="user-name">{{
                    user.displayName || user.firstName + " " + user.lastName
                  }}</span>
                  @if (getUserRole(user); as role) {
                    <span class="user-role">{{ role }}</span>
                  }
                </div>
                @if (canImpersonateDealerUser() && user.userId) {
                  <span class="store-login" (click)="impersonateUser(user)"
                    >Store login</span
                  >
                } @else if (!user.userId) {
                  <span class="resend-invite" (click)="resendInvite(user)"
                    >Resend invite</span
                  >
                }
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
</div>
